import "channels";
import { Turbo } from "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import Rails from "@rails/ujs";

Rails.start();
ActiveStorage.start();
Turbo.setProgressBarDelay(250);

// turbo での画面遷移もログに残す。
import { setUpTurboDriveLog, setUpTurboFrameLog } from "../shared/turbo_log";
setUpTurboDriveLog();
setUpTurboFrameLog();

import { TwilioConnection } from "../shared/TwilioConnection";
window.TwilioConnection = new TwilioConnection();

// jquery を使うライブラリ
require("bootstrap4");
// drawer menu http://git.blivesta.com/drawer/
require("jquery-drawer");

import { BootstrapWrapperBootstrap4 } from "../shared/BootstrapWrapperBootstrap4";
window.BootstrapWrapper = new BootstrapWrapperBootstrap4();

// stimulus
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
const application = Application.start();
window.Stimulus = application;

const sharedContext = require.context("../controllers/shared", true, /\.js$/);
application.load(definitionsFromContext(sharedContext));
const userContext = require.context("../controllers/user", true, /\.js$/);
application.load(definitionsFromContext(userContext));

// Hot Module Replacement (HMR) for Stimulus controllers
// prod はHMR OFFでコンパイルされるので以下のブロックは除去される
if (module.hot) {
  module.hot.accept(sharedContext.id, () => {
    // accept の中で require.context をリロードする必要がある
    const ctx = require.context("../controllers/shared", true, /\.js$/);
    application.load(definitionsFromContext(ctx));
  });
  module.hot.accept(userContext.id, () => {
    const ctx = require.context("../controllers/user", true, /\.js$/);
    application.load(definitionsFromContext(ctx));
  });
}

// Support component names relative to this directory:
const componentRequireContext = require.context("components", true);
import ReactRailsUJS from "react_ujs";
ReactRailsUJS.useContext(componentRequireContext);
